import { defineStore } from 'pinia';
import { useRoute } from 'vue-router';
import type { identifier } from '@core/models/base';
import type { StudioDisplayModel } from '@shared/models/studios/studios';
import { getStudioDetails } from '../services/studioAdminStudio.service';
import type { StudioEarnedTotals } from '../services/studioAdminReports.service';
import { fetchStudioPaymentSummaries } from '../services/studioAdminReports.service';

export interface StudioAdminStudioState {
  loading: boolean;
  studioId: identifier;
  studioDetails?: StudioDisplayModel;
  totals?: StudioEarnedTotals;
}
export const useStudioAdminStudioStore = defineStore('studioadminstudio', {
  state: (): StudioAdminStudioState => ({
    loading: false,
    studioId: 0,
    studioDetails: undefined,
    totals: undefined,
  }),
  getters: {
    apiRootUrl: (state) => `/api/studioadmin/studios/${state.studioId}`,
    hasJobs: (state) => state.studioDetails?.hasLegacyJobs || state.studioDetails?.hasRSPOJobs,
  },
  actions: {
    updateStudioDetails(update: StudioDisplayModel) {
      this.studioDetails = update;
    },
    async initialize(studioId?: identifier) {
      if (!studioId) {
        const { studioId: studioIdUrl } = useRoute().params;
        studioId = parseInt(studioIdUrl as string, 10);
      }
      if (studioId !== this.studioId || !this.studioDetails) {
        this.loading = true;
        const details = await getStudioDetails(studioId);
        this.studioDetails = details;
        this.studioId = details.id;
        this.loading = false;
      }
    },
    async fetchStudioEarnedTotals() {
      if (this.studioId) {
        this.totals = await fetchStudioPaymentSummaries(this.studioId);
      }
    },
    clear() {
      this.studioId = 0;
      this.studioDetails = undefined;
      this.totals = undefined;
    },
  },
});
